import { useState, useEffect, useRef } from "react";
import axios from "../../api/axios";
import axiosInstance from "../../api/axios";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import "./AlumniProfile.css";
import Select from "react-select";
import { Modal, Box, Dialog, DialogTitle, DialogContent } from "@mui/material";
import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import {
  getUndergraduateSchoolProgramMap,
  getPostgraduateSchoolProgramMap,
} from "../../utils/programOptions";

const API_BASE_URL = axiosInstance.defaults.baseURL;

function AlumniProfile() {
  // WebSocket connection
  useEffect(() => {
    const timeout = setTimeout(() => {
      const socket = new WebSocket(`ws://${window.location.hostname}:5001/ws`);

      socket.onopen = () => {
        // console.log('✅ WebSocket connected');
        socket.send("Hello server");
      };

      // socket.onmessage = (event) => {
      //   console.log('📩 Message from server:', event.data);
      // };

      socket.onclose = () => {
        console.log("❌ WebSocket disconnected");
      };
    }, 200); // delay connection

    return () => clearTimeout(timeout);
  }, []);
  const [tabValue, setTabValue] = useState(0);
  const [profile, setProfile] = useState({
    // Account Information
    email: "",
    password: "",
    confirmPassword: "",

    // Personal Information
    firstName: "",
    middleName: "",
    lastName: "",
    suffix: "",
    idNo: "",
    birthday: "",

    // Father's Information
    fatherFirstName: "",
    fatherMiddleName: "",
    fatherLastName: "",
    fatherSuffix: "",

    // Mother's Information
    motherFirstName: "",
    motherMiddleName: "",
    motherLastName: "",
    motherSuffix: "",

    // Educational Information
    schoolUndergraduate: "",
    programUndergraduate: "",
    schoolPostgraduate: "",
    programPostgraduate: "",
    recentGraduate: "",
    elementarySMU: "",
    juniorHighSMU: "",
    highSchoolSMU: "",
    hsOrShsSMU: "",
    seniorHighSMU: "",
    strandInSMU: "",
    tertiarySMU: "",
    nonGraduateSMU: "",

    // Employment and Contact Information
    employmentStatus: "",
    currentWork: "",
    companyName: "",
    companyAddress: "",
    address: "",
    facebookAccount: "",
    contactNumber: "",
    achievements: ["", "", "", "", ""],

    // Files and Photos
    photo: null,
    curriculumVitae: null,
    alumniIdApplication: null,
    signature: null,
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const sigCanvasRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const schoolProgramMapUndergraduate =
    getUndergraduateSchoolProgramMap(profile.tertiarySMU) || {};
  const schoolProgramMapPostgraduate =
    getPostgraduateSchoolProgramMap(profile.tertiarySMU) || {};
  const availableUndergraduatePrograms =
    schoolProgramMapUndergraduate[profile.schoolUndergraduate] || [];
  const availablePostgraduatePrograms =
    schoolProgramMapPostgraduate[profile.schoolPostgraduate] || [];
  const { user } = useContext(AuthContext);
  const [openImageModal, setOpenImageModal] = useState(false);
  const [modalImageSrc, setModalImageSrc] = useState("");
  const [filePreviewOpen, setFilePreviewOpen] = useState(false);
  const [previewFileUrl, setPreviewFileUrl] = useState("");
  const [previewFileType, setPreviewFileType] = useState("");

  const undergraduateProgramOptions = availableUndergraduatePrograms.map(
    (program) => ({
      label: program,
      value: program,
    }),
  );

  const postgraduateProgramOptions = availablePostgraduatePrograms.map(
    (program) => ({
      label: program,
      value: program,
    }),
  );

  const tabsRef = useRef(null);
  const scrollTabsLeft = () => {
    if (tabsRef.current) {
      tabsRef.current.scrollBy({ left: -150, behavior: "smooth" });
    }
  };

  // Success/Error Toast
  useEffect(() => {
    if (toast) {
      const timer = setTimeout(() => {
        setToast(false);
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [toast]);

  const scrollTabsRight = () => {
    if (tabsRef.current) {
      tabsRef.current.scrollBy({ left: 150, behavior: "smooth" });
    }
  };
  // const clearSignature = () => {
  //   if (sigCanvasRef.current) {
  //     sigCanvasRef.current.clear();
  //   }
  // };

  // Fetch profile
  useEffect(() => {
    if (!user) return;

    const fetchProfile = async () => {
      try {
        const res = await axios.get(`/api/alumni/alumni/${user._id}`);

        const {
          parents,
          smuHistory,
          employment,
          photo,
          signature,
          ...flatData
        } = res.data;

        const unpacked = {
          ...flatData,

          // Parents
          fatherFirstName: parents?.father?.firstName || "",
          fatherMiddleName: parents?.father?.middleName || "",
          fatherLastName: parents?.father?.lastName || "",
          fatherSuffix: parents?.father?.suffix || "",

          motherFirstName: parents?.mother?.firstName || "",
          motherMiddleName: parents?.mother?.middleName || "",
          motherLastName: parents?.mother?.lastName || "",
          motherSuffix: parents?.mother?.suffix || "",

          // Education
          schoolUndergraduate: res.data.schoolUndergraduate || "",
          programUndergraduate: res.data.programUndergraduate || "",
          schoolPostgraduate: res.data.schoolPostgraduate || "",
          programPostgraduate: res.data.programPostgraduate || "",

          // SMU History
          recentGraduate: smuHistory?.recentGraduate?.toLowerCase() || "",
          elementarySMU: smuHistory?.elementarySMU || "",
          juniorHighSMU: smuHistory?.juniorHighSMU || "",
          highSchoolSMU: smuHistory?.highSchoolSMU || "",
          hsOrShsSMU: smuHistory?.hsOrShsSMU || "",
          seniorHighSMU: smuHistory?.seniorHighSMU || "",
          strandInSMU: smuHistory?.strandInSMU || "",
          tertiarySMU: smuHistory?.tertiarySMU || "",
          nonGraduateSMU: smuHistory?.nonGraduateSMU || "",

          // Employment
          employmentStatus: employment?.employmentStatus || "",
          currentWork: employment?.currentWork || "",
          companyName: employment?.companyName || "",
          companyAddress: employment?.companyAddress || "",

          // Photo (just filePath)
          photo: photo?.filePath || "",
          signature: signature?.filePath || "",
        };

        setProfile((prev) => ({
          ...prev,
          ...unpacked,
          password: "",
          confirmPassword: "",
        }));
        // console.log('Fetched alumni profile data:', res.data);
      } catch (err) {
        console.error("Error fetching profile", err.response?.data || err);
      }
    };

    fetchProfile();
  }, [user]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "tertiarySMU") {
      // Program lists depend on graduation era, so clear stale selections
      // whenever the graduation year changes.
      setProfile((prevProfile) => ({
        ...prevProfile,
        tertiarySMU: value,
        schoolUndergraduate: "",
        programUndergraduate: "",
        schoolPostgraduate: "",
        programPostgraduate: "",
      }));
      return;
    }

    setProfile((prevProfile) => ({
      ...prevProfile,
      [name]: value,
    }));
  };

  // Function to handle achievement changes
  const handleAchievementChange = (index, value) => {
    const updatedAchievements = [...profile.achievements];
    updatedAchievements[index] = value;
    setProfile({ ...profile, achievements: updatedAchievements });
  };

  // Function to handle profile picture upload
  const handleFileChange = (e, field) => {
    const file = e.target.files[0];
    if (!file) return;

    const isImage = file.type.startsWith("image/");
    // const isPDF = file.type === 'application/pdf';

    const reader = new FileReader();
    reader.onloadend = () => {
      if (field === "photo") {
        setProfile((prev) => ({
          ...prev,
          photo: file,
          photoPreview: reader.result,
        }));
      } else if (field === "signature" && isImage) {
        setProfile((prev) => ({
          ...prev,
          signature: file,
          signaturePreview: reader.result,
        }));
      } else if (
        field === "curriculumVitae" ||
        field === "alumniIdApplication"
      ) {
        // Just set the file (no preview for PDFs)
        setProfile((prev) => ({
          ...prev,
          [field]: file,
        }));
      }
    };

    if (isImage && (field === "photo" || field === "signature")) {
      reader.readAsDataURL(file);
    } else {
      // No need to read file if not used for preview (PDFs)
      setProfile((prev) => ({
        ...prev,
        [field]: file,
      }));
    }
  };

  // Function to save changes
  const handleSave = async () => {
    if (profile.password !== profile.confirmPassword) {
      alert("Passwords do not match");
      return;
    }

    try {
      const formData = new FormData();

      // Flat fields
      formData.append("email", profile.email);
      formData.append("password", profile.password);
      formData.append("confirmPassword", profile.confirmPassword);
      formData.append("idNo", profile.idNo);
      formData.append("firstName", profile.firstName);
      formData.append("middleName", profile.middleName);
      formData.append("lastName", profile.lastName);
      formData.append("suffix", profile.suffix);
      formData.append("birthday", profile.birthday);
      formData.append("fatherFirstName", profile.fatherFirstName);
      formData.append("fatherMiddleName", profile.fatherMiddleName);
      formData.append("fatherLastName", profile.fatherLastName);
      formData.append("fatherSuffix", profile.fatherSuffix);
      formData.append("motherFirstName", profile.motherFirstName);
      formData.append("motherMiddleName", profile.motherMiddleName);
      formData.append("motherLastName", profile.motherLastName);
      formData.append("motherSuffix", profile.motherSuffix);

      formData.append("schoolUndergraduate", profile.schoolUndergraduate);
      formData.append("programUndergraduate", profile.programUndergraduate);
      formData.append("schoolPostgraduate", profile.schoolPostgraduate);
      formData.append("programPostgraduate", profile.programPostgraduate);
      formData.append("recentGraduate", profile.recentGraduate);
      formData.append("elementarySMU", profile.elementarySMU);
      formData.append("juniorHighSMU", profile.juniorHighSMU);
      formData.append("highSchoolSMU", profile.highSchoolSMU);
      formData.append("hsOrShsSMU", profile.hsOrShsSMU);
      formData.append("seniorHighSMU", profile.seniorHighSMU);
      formData.append("strandInSMU", profile.strandInSMU);
      formData.append("tertiarySMU", profile.tertiarySMU);
      formData.append("nonGraduateSMU", profile.nonGraduateSMU);

      formData.append("employmentStatus", profile.employmentStatus);
      formData.append(
        "otherEmploymentStatus",
        profile.otherEmploymentStatus || "",
      );
      formData.append("currentWork", profile.currentWork);
      formData.append("companyName", profile.companyName);
      formData.append("companyAddress", profile.companyAddress);
      formData.append("address", profile.address);
      formData.append("facebookAccount", profile.facebookAccount);
      formData.append("contactNumber", profile.contactNumber);

      // Achievements array as JSON string
      const cleanedAchievements = profile.achievements?.filter(
        (a) => a?.trim() !== "",
      );
      formData.append("achievements", JSON.stringify(cleanedAchievements));

      // Files
      if (profile.photo && typeof profile.photo !== "string") {
        formData.append("photo", profile.photo);
      }

      if (
        profile.curriculumVitae &&
        typeof profile.curriculumVitae !== "string"
      ) {
        formData.append("curriculumVitae", profile.curriculumVitae);
      }

      if (
        profile.alumniIdApplication &&
        typeof profile.alumniIdApplication !== "string"
      ) {
        formData.append("alumniIdApplication", profile.alumniIdApplication);
      }

      if (profile.signature && typeof profile.signature !== "string") {
        formData.append("signature", profile.signature);
      } else if (sigCanvasRef.current && !sigCanvasRef.current.isEmpty()) {
        const sigData = sigCanvasRef.current
          .getTrimmedCanvas()
          .toDataURL("image/png");
        const blob = await (await fetch(sigData)).blob();
        formData.append("signature", blob, `signature-${profile.idNo}.png`);
      }

      const res = await axiosInstance.put(
        `/api/alumni/alumni/${profile._id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          withCredentials: true,
        },
      );

      if (res.status !== 200 && res.status !== 201) {
        console.error("❌ Error:", res.data);
        alert(res.data?.message || "Update failed");
        return;
      }

      // ✅ Axios gives you parsed JSON already
      setToastMessage("Profile updated successfully!");
      setToast(true);
      setOpen(false);
    } catch (error) {
      console.error("❌ Update failed:", error);
      setToastMessage("Failed to update profile.");
    }
  };

  return (
    <div className="alumni-profile-wrapper">
      <div className="alumni-profile-header">
        <h2 className="alumni-profile-title">
          {profile.firstName} {profile.middleName} {profile.lastName} Profile
        </h2>
      </div>

      <p className="alumni-profile-note">
        NOTE: Save changes to update your profile at Employment & Contact.
      </p>

      <div className="alumni-profile-paper">
        <div className="alumni-profile-tab-wrapper">
          <button className="scroll-arrow left" onClick={scrollTabsLeft}>
            &lt;
          </button>

          <div className="alumni-profile-tabs" ref={tabsRef}>
            <button
              className={`alumni-profile-tab ${tabValue === 0 ? "active" : ""}`}
              onClick={() => setTabValue(0)}
            >
              Account Information
            </button>
            <button
              className={`alumni-profile-tab ${tabValue === 1 ? "active" : ""}`}
              onClick={() => setTabValue(1)}
            >
              Personal Information
            </button>
            <button
              className={`alumni-profile-tab ${tabValue === 2 ? "active" : ""}`}
              onClick={() => setTabValue(2)}
            >
              Educational Information
            </button>
            <button
              className={`alumni-profile-tab ${tabValue === 3 ? "active" : ""}`}
              onClick={() => setTabValue(3)}
            >
              Employment & Contact
            </button>
          </div>

          <button className="scroll-arrow right" onClick={scrollTabsRight}>
            &gt;
          </button>
        </div>

        {/* Account Information */}
        {tabValue === 0 && (
          <div className="alumni-profile-tab-panel">
            <h3 className="alumni-profile-section-title">
              Account Information
            </h3>
            <div className="alumni-profile-grid">
              <div className="alumni-profile-col col-4">
                <label>Email</label>
                <input
                  type="email"
                  name="email"
                  value={profile.email}
                  onChange={handleChange}
                  className="alumni-profile-input"
                />
              </div>

              <div className="alumni-profile-col col-4">
                <label>Password</label>
                <div className="alumni-password-field">
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    value={profile.password}
                    onChange={handleChange}
                    className="alumni-profile-input"
                  />
                  <span
                    className="toggle-password-icon"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </span>
                </div>
              </div>

              <div className="alumni-profile-col col-4">
                <label>Confirm Password</label>
                <div className="alumni-password-field">
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    name="confirmPassword"
                    value={profile.confirmPassword}
                    onChange={handleChange}
                    className="alumni-profile-input"
                  />
                  <span
                    className="toggle-password-icon"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  >
                    {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Personal Information */}
        {tabValue === 1 && (
          <div className="alumni-profile-tab-panel">
            <h3 className="alumni-profile-section-title">
              Personal Information
            </h3>

            <div className="alumni-profile-grid">
              {/* Personal Details */}

              <div className="alumni-profile-col col-3">
                <label>Last Name</label>
                <input
                  type="text"
                  name="lastName"
                  value={profile.lastName}
                  onChange={handleChange}
                  className="alumni-profile-input"
                />
              </div>
              <div className="alumni-profile-col col-3">
                <label>Middle Name</label>
                <input
                  type="text"
                  name="middleName"
                  value={profile.middleName}
                  onChange={handleChange}
                  className="alumni-profile-input"
                />
              </div>

              <div className="alumni-profile-col col-3">
                <label>First Name</label>
                <input
                  type="text"
                  name="firstName"
                  value={profile.firstName}
                  onChange={handleChange}
                  className="alumni-profile-input"
                />
              </div>

              <div className="alumni-profile-col col-3">
                <label>Suffix</label>
                <input
                  type="text"
                  name="suffix"
                  value={profile.suffix}
                  onChange={handleChange}
                  className="alumni-profile-input"
                />
              </div>

              <div className="alumni-profile-col col-6">
                <label>ID Number</label>
                <input
                  type="text"
                  name="idNo"
                  value={profile.idNo}
                  onChange={handleChange}
                  className="alumni-profile-input"
                />
              </div>

              <div className="alumni-profile-col col-6">
                <label>Birthday</label>
                <input
                  type="date"
                  name="birthday"
                  value={profile.birthday?.split("T")[0] || ""}
                  onChange={handleChange}
                  className="alumni-profile-input"
                />
              </div>

              {/* Father's Info */}
              <div className="alumni-profile-col col-12">
                <h4 className="alumni-profile-subheading">Father's Name</h4>
              </div>

              <div className="alumni-profile-col col-3">
                <label>Last Name</label>
                <input
                  type="text"
                  name="fatherLastName"
                  value={profile.fatherLastName}
                  onChange={handleChange}
                  className="alumni-profile-input"
                />
              </div>

              <div className="alumni-profile-col col-3">
                <label>Middle Name</label>
                <input
                  type="text"
                  name="fatherMiddleName"
                  value={profile.fatherMiddleName}
                  onChange={handleChange}
                  className="alumni-profile-input"
                />
              </div>

              <div className="alumni-profile-col col-3">
                <label>First Name</label>
                <input
                  type="text"
                  name="fatherFirstName"
                  value={profile.fatherFirstName}
                  onChange={handleChange}
                  className="alumni-profile-input"
                />
              </div>

              <div className="alumni-profile-col col-3">
                <label>Suffix</label>
                <input
                  type="text"
                  name="fatherSuffix"
                  value={profile.fatherSuffix}
                  onChange={handleChange}
                  className="alumni-profile-input"
                />
              </div>

              {/* Mother's Info */}
              <div className="alumni-profile-col col-12">
                <h4 className="alumni-profile-subheading">
                  Mother's Maiden Name
                </h4>
              </div>
              <div className="alumni-profile-col col-3">
                <label>Maiden Last Name</label>
                <input
                  type="text"
                  name="motherLastName"
                  value={profile.motherLastName}
                  onChange={handleChange}
                  className="alumni-profile-input"
                />
              </div>

              <div className="alumni-profile-col col-3">
                <label>Maiden Middle Name</label>
                <input
                  type="text"
                  name="motherMiddleName"
                  value={profile.motherMiddleName}
                  onChange={handleChange}
                  className="alumni-profile-input"
                />
              </div>

              <div className="alumni-profile-col col-3">
                <label>First Name</label>
                <input
                  type="text"
                  name="motherFirstName"
                  value={profile.motherFirstName}
                  onChange={handleChange}
                  className="alumni-profile-input"
                />
              </div>
              <div className="alumni-profile-col col-3">
                <label>Suffix</label>
                <input
                  type="text"
                  name="motherSuffix"
                  value={profile.motherSuffix}
                  onChange={handleChange}
                  className="alumni-profile-input"
                />
              </div>
            </div>
          </div>
        )}

        {/* Educational Information */}
        {tabValue === 2 && (
          <div className="alumni-profile-tab-panel">
            <h3 className="alumni-profile-section-title">
              Educational Information
            </h3>

            <div className="alumni-profile-grid">
              <div className="alumni-profile-col col-6">
                <label>Tertiary (SMU?)</label>
                <input
                  type="text"
                  name="tertiarySMU"
                  value={profile.tertiarySMU}
                  onChange={handleChange}
                  placeholder="If YES, State year of graduation. If NO, enter N/A"
                  className="alumni-profile-input"
                />
                <small>
                  Your year of graduation determines which schools/programs
                  are available below.
                </small>
              </div>

              <div className="alumni-profile-col col-12">
                <h4 className="alumni-profile-subheading">
                  Undergraduate Program
                </h4>
              </div>
              <div className="alumni-profile-col col-6">
                <label htmlFor="schoolUndergraduate">School/College</label>
                <select
                  name="schoolUndergraduate"
                  id="schoolUndergraduate"
                  value={profile.schoolUndergraduate}
                  onChange={handleChange}
                  className="alumni-profile-input"
                  disabled={Object.keys(schoolProgramMapUndergraduate).length === 0}
                >
                  <option value="">
                    {Object.keys(schoolProgramMapUndergraduate).length === 0
                      ? "Enter your year of graduation above first"
                      : "Select School"}
                  </option>
                  {Object.keys(schoolProgramMapUndergraduate).map(
                    (school, index) => (
                      <option key={index} value={school}>
                        {school}
                      </option>
                    ),
                  )}
                </select>
              </div>

              <div className="alumni-profile-col col-6">
                <label htmlFor="programUndergraduate">Course/Program</label>
                <Select
                  id="programUndergraduate"
                  options={undergraduateProgramOptions}
                  value={
                    undergraduateProgramOptions.find(
                      (opt) => opt.value === profile.programUndergraduate,
                    ) || null
                  }
                  onChange={(selectedOption) =>
                    handleChange({
                      target: {
                        name: "programUndergraduate",
                        value: selectedOption?.value || "",
                      },
                    })
                  }
                  isDisabled={undergraduateProgramOptions.length === 0}
                  className="alumni-profile-select"
                  placeholder="Select a course/program"
                />
              </div>

              <div className="alumni-profile-col col-12">
                <h4 className="alumni-profile-subheading">
                  Postgraduate Program (Optional)
                </h4>
              </div>
              <div className="alumni-profile-col col-6">
                <label htmlFor="schoolPostgraduate">School/College</label>
                <select
                  name="schoolPostgraduate"
                  id="schoolPostgraduate"
                  value={profile.schoolPostgraduate}
                  onChange={handleChange}
                  className="alumni-profile-input"
                >
                  <option value="">Select School (Optional)</option>
                  {Object.keys(schoolProgramMapPostgraduate).map(
                    (school, index) => (
                      <option key={index} value={school}>
                        {school}
                      </option>
                    ),
                  )}
                </select>
              </div>

              <div className="alumni-profile-col col-6">
                <label htmlFor="programPostgraduate">Course/Program</label>
                <Select
                  id="programPostgraduate"
                  options={postgraduateProgramOptions}
                  value={
                    postgraduateProgramOptions.find(
                      (opt) => opt.value === profile.programPostgraduate,
                    ) || null
                  }
                  onChange={(selectedOption) =>
                    handleChange({
                      target: {
                        name: "programPostgraduate",
                        value: selectedOption?.value || "",
                      },
                    })
                  }
                  isDisabled={postgraduateProgramOptions.length === 0}
                  className="alumni-profile-select"
                  placeholder="Select a course/program"
                />
              </div>

              <div className="alumni-profile-col col-12">
                <label>Are you a graduate for the past five years?</label>
                <div className="alumni-profile-radio-group">
                  <label>
                    <input
                      type="radio"
                      name="recentGraduate"
                      value="yes"
                      checked={profile.recentGraduate === "yes"}
                      onChange={handleChange}
                    />
                    Yes
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="recentGraduate"
                      value="no"
                      checked={profile.recentGraduate === "no"}
                      onChange={handleChange}
                    />
                    No
                  </label>
                </div>
              </div>

              <div className="alumni-profile-col col-6">
                <label>Grade School (SMU?)</label>
                <input
                  type="text"
                  name="elementarySMU"
                  value={profile.elementarySMU}
                  onChange={handleChange}
                  placeholder="If YES, State year of graduation. If NO, enter N/A"
                  className="alumni-profile-input"
                />
              </div>

              <div className="alumni-profile-col col-6">
                <label>Junior High (SMU?)</label>
                <input
                  type="text"
                  name="juniorHighSMU"
                  value={profile.juniorHighSMU}
                  onChange={handleChange}
                  placeholder="If YES, State year of graduation. If NO, enter N/A"
                  className="alumni-profile-input"
                />
              </div>

              <div className="alumni-profile-col col-6">
                <label>High School (SMU?)</label>
                <input
                  type="text"
                  name="highSchoolSMU"
                  value={profile.highSchoolSMU}
                  onChange={handleChange}
                  placeholder="If YES, State year of graduation. If NO, enter N/A"
                  className="alumni-profile-input"
                />
              </div>

              <div className="alumni-profile-col col-6">
                <label>High School or Science High School?</label>
                <input
                  type="text"
                  name="hsOrShsSMU"
                  value={profile.hsOrShsSMU}
                  onChange={handleChange}
                  placeholder="Enter HS or Science HS"
                  className="alumni-profile-input"
                />
              </div>

              <div className="alumni-profile-col col-3">
                <label>Senior High (SMU?)</label>
                <input
                  type="text"
                  name="seniorHighSMU"
                  value={profile.seniorHighSMU}
                  onChange={handleChange}
                  placeholder="If YES, State year of graduation. If NO, enter N/A"
                  className="alumni-profile-input"
                />
              </div>

              <div className="alumni-profile-col col-3">
                <label>Strand in SMU</label>
                <input
                  type="text"
                  name="strandInSMU"
                  value={profile.strandInSMU}
                  onChange={handleChange}
                  placeholder="If applicable"
                  className="alumni-profile-input"
                />
              </div>

              <div className="alumni-profile-col col-12">
                <label>Studied in SMU but did not graduate?</label>
                <input
                  type="text"
                  name="nonGraduateSMU"
                  value={profile.nonGraduateSMU}
                  onChange={handleChange}
                  placeholder="Year and level last attended, or N/A"
                  className="alumni-profile-input"
                />
              </div>
            </div>
          </div>
        )}

        {/* Employment and Contact Information */}
        {tabValue === 3 && (
          <div className="alumni-profile-tab-panel">
            <h3 className="alumni-profile-section-title">
              Employment and Contact Information
            </h3>

            <div className="alumni-profile-grid">
              <div className="alumni-profile-col col-4">
                <label>Employment Status</label>
                <select
                  name="employmentStatus"
                  value={profile.employmentStatus}
                  onChange={handleChange}
                  className="alumni-profile-input"
                >
                  <option value="">Select one</option>
                  <option value="Employed">Employed</option>
                  <option value="Government Employee">
                    Government Employee
                  </option>
                  <option value="Private Employee">Private Employee</option>
                  <option value="Self-Employed">Self-Employed</option>
                  <option value="N/A">N/A</option>
                  <option value="Other">Other</option>
                </select>
              </div>

              <div className="alumni-profile-col col-4">
                <label>Current Work/Position</label>
                <input
                  type="text"
                  name="currentWork"
                  value={profile.currentWork}
                  onChange={handleChange}
                  className="alumni-profile-input"
                />
              </div>

              <div className="alumni-profile-col col-4">
                <label>Company Name</label>
                <input
                  type="text"
                  name="companyName"
                  value={profile.companyName}
                  onChange={handleChange}
                  className="alumni-profile-input"
                />
              </div>

              <div className="alumni-profile-col col-4">
                <label>Company Address</label>
                <input
                  type="text"
                  name="companyAddress"
                  value={profile.companyAddress}
                  onChange={handleChange}
                  className="alumni-profile-input"
                />
              </div>

              <div className="alumni-profile-col col-12">
                <label>Home Address</label>
                <input
                  type="text"
                  name="address"
                  placeholder="Town and Province/State and Country"
                  value={profile.address}
                  onChange={handleChange}
                  className="alumni-profile-input"
                />
              </div>

              <div className="alumni-profile-col col-6">
                <label>Facebook Account</label>
                <input
                  type="text"
                  name="facebookAccount"
                  value={profile.facebookAccount}
                  onChange={handleChange}
                  className="alumni-profile-input"
                />
              </div>

              <div className="alumni-profile-col col-6">
                <label>Contact Number</label>
                <input
                  type="text"
                  name="contactNumber"
                  value={profile.contactNumber}
                  onChange={handleChange}
                  className="alumni-profile-input"
                />
              </div>

              {/* Achievements */}
              <div className="alumni-profile-col col-12">
                <h4 className="alumni-profile-subheading">
                  Top 5 Achievements
                </h4>
              </div>

              {[0, 1, 2, 3, 4].map((index) => (
                <div className="alumni-profile-col col-12" key={index}>
                  <label>Achievement {index + 1}</label>
                  <input
                    type="text"
                    value={profile.achievements?.[index] || ""}
                    onChange={(e) =>
                      handleAchievementChange(index, e.target.value)
                    }
                    className="alumni-profile-input"
                  />
                </div>
              ))}
            </div>

            {/* Section Divider */}
            <hr className="alumni-profile-divider" />

            {/* Uploads Section */}
            <div className="alumni-profile-grid">
              {/* Profile Photo Upload */}
              <Modal
                open={openImageModal}
                onClose={() => setOpenImageModal(false)}
                aria-labelledby="modal-image-preview"
                aria-describedby="modal-preview-of-uploaded-image"
              >
                <Box
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    bgcolor: "background.paper",
                    boxShadow: 24,
                    p: 2,
                    maxWidth: "90vw",
                    maxHeight: "90vh",
                    outline: "none",
                  }}
                >
                  <img
                    src={modalImageSrc}
                    alt="Full Preview"
                    style={{ maxWidth: "100%", maxHeight: "80vh" }}
                  />
                </Box>
              </Modal>
              <div className="alumni-profile-col col-6">
                <div className="alumni-profile-upload-section">
                  <h4 className="alumni-profile-subheading">Photo</h4>
                  {profile.photo ? (
                    <>
                      <img
                        src={
                          profile.photoPreview ||
                          `${API_BASE_URL}/${profile.photo}`
                        }
                        alt="Profile"
                        className="alumni-profile-avatar"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setModalImageSrc(
                            profile.photoPreview ||
                              `${API_BASE_URL}/${profile.photo}`,
                          );
                          setOpenImageModal(true);
                        }}
                      />
                    </>
                  ) : (
                    <div className="alumni-profile-avatar placeholder">
                      <span>Photo</span>
                    </div>
                  )}

                  <label className="alumni-profile-upload-button">
                    Upload Photo
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) => handleFileChange(e, "photo")}
                      hidden
                    />
                  </label>
                </div>
              </div>

              <Dialog
                open={filePreviewOpen}
                onClose={() => setFilePreviewOpen(false)}
                maxWidth="md"
                fullWidth
              >
                <DialogTitle>File Preview</DialogTitle>
                <DialogContent dividers style={{ textAlign: "center" }}>
                  {previewFileType === "pdf" ? (
                    <iframe
                      src={previewFileUrl}
                      width="100%"
                      height="600px"
                      style={{ border: "none" }}
                      title="File Preview"
                    />
                  ) : (
                    <p>Unsupported file type for preview</p>
                  )}
                </DialogContent>
              </Dialog>

              {/* Signature Upload */}
              <div className="alumni-profile-col col-6">
                <div className="alumni-profile-upload-section">
                  <h4 className="alumni-profile-subheading">Signature</h4>

                  {/* Signature Preview */}
                  {profile.signaturePreview ? (
                    <img
                      src={profile.signaturePreview}
                      alt="Signature"
                      style={{
                        width: "200px",
                        height: "100px",
                        border: "1px solid #ccc",
                      }}
                    />
                  ) : profile.signature &&
                    typeof profile.signature === "string" ? (
                    <img
                      src={`${API_BASE_URL}/${profile.signature}`}
                      alt="Signature"
                      style={{
                        width: "200px",
                        height: "150px",
                        border: "1px solid #ccc",
                      }}
                    />
                  ) : (
                    <p className="muted">No signature uploaded</p>
                  )}

                  {/* File Upload */}
                  <label className="alumni-profile-upload-button">
                    Upload Signature
                    <input
                      type="file"
                      accept="image/*"
                      hidden
                      onChange={(e) => handleFileChange(e, "signature")}
                    />
                  </label>

                  {/* <p className="alumni-profile-sign-instruction">
                        Or Sign Below:
                      </p>

                      <div className="alumni-profile-sign-box">
                        <SignatureCanvas
                          ref={sigCanvasRef}
                          penColor="black"
                          canvasProps={{
                            width: 400,
                            height: 150,
                            className: 'sigCanvas',
                          }}
                        />
                      </div>

                      <button
                        type="button"
                        className="alumni-profile-upload-button outline"
                        onClick={clearSignature}
                      >
                        Clear
                      </button> */}
                </div>
              </div>

              {/* CV Upload */}
              <div className="alumni-profile-col col-6">
                <div className="alumni-profile-upload-section">
                  <h4 className="alumni-profile-subheading">
                    Curriculum Vitae (Optional)
                  </h4>
                  <div className="alumni-profile-file-status">
                    {profile.curriculumVitae ? (
                      <button
                        className="alumni-profile-preview-link"
                        onClick={() => {
                          setPreviewFileUrl(
                            `${API_BASE_URL}/${
                              profile.curriculumVitae.filePath ||
                              profile.curriculumVitae
                            }`,
                          );
                          setPreviewFileType("pdf");
                          setFilePreviewOpen(true);
                        }}
                      >
                        View Your CV
                      </button>
                    ) : (
                      <p className="muted">No file uploaded</p>
                    )}
                  </div>
                  <label className="alumni-profile-upload-button">
                    Upload CV
                    <input
                      type="file"
                      accept=".pdf,.doc,.docx"
                      onChange={(e) => handleFileChange(e, "curriculumVitae")}
                      hidden
                    />
                  </label>
                </div>
              </div>

              {/* Alumni ID Upload */}
              <div className="alumni-profile-col col-6">
                <div className="alumni-profile-upload-section">
                  <h4 className="alumni-profile-subheading">
                    Alumni ID Application (Optional)
                  </h4>
                  <div className="alumni-profile-file-status">
                    {profile.alumniIdApplication ? (
                      <button
                        className="alumni-profile-preview-link"
                        onClick={() => {
                          setPreviewFileUrl(
                            `${API_BASE_URL}/${
                              profile.alumniIdApplication.filePath ||
                              profile.alumniIdApplication
                            }`,
                          );
                          setPreviewFileType("pdf");
                          setFilePreviewOpen(true);
                        }}
                      >
                        View Your Alumni ID Application
                      </button>
                    ) : (
                      <p className="muted">No file uploaded</p>
                    )}
                  </div>
                  <label className="alumni-profile-upload-button">
                    Upload Application
                    <input
                      type="file"
                      accept=".pdf,.doc,.docx"
                      onChange={(e) =>
                        handleFileChange(e, "alumniIdApplication")
                      }
                      hidden
                    />
                  </label>
                </div>
              </div>
            </div>

            {/* Save Button */}
            <div className="alumni-profile-save-wrap">
              <button
                className="alumni-profile-save-button"
                onClick={() => setOpen(true)}
              >
                Save Profile
              </button>
            </div>
          </div>
        )}

        {open && (
          <div className="alumni-profile-modal-overlay">
            <div className="alumni-profile-modal">
              <h3>Confirm Update</h3>
              <p>Are you sure you want to update your profile?</p>
              <div className="alumni-profile-modal-buttons">
                <button onClick={() => setOpen(false)} className="cancel">
                  Cancel
                </button>
                <button
                  className="confirm"
                  onClick={() => {
                    setOpen(false);
                    handleSave();
                  }}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        )}
        {toast && <div className="alumni-profile-toast">{toastMessage}</div>}
      </div>
    </div>
  );
}

export default AlumniProfile;
